import React, { useRef } from 'react';
import '../Accounting/Accounting.css';
import { useReactToPrint } from 'react-to-print';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { QRCodeCanvas } from 'qrcode.react';

const DeliveryOrderModal = ({ show, onClose, deliveryData }) => {
  const { t, i18n } = useTranslation();
  const componentRef = useRef();

  const formatNumber = (number, locale) => {
    const parsedNumber = parseFloat(number);
    if (isNaN(parsedNumber)) {
      return '0.00';
    }
    return new Intl.NumberFormat(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(parsedNumber);
  };

  const formatDate = (dateString, locale) => {
    const date = new Date(dateString);
    return moment(date).format('DD MMM YYYY');
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return 'Pending';
    const date = new Date(dateString);
    return moment(date).format('DD MMM YYYY HH:mm');
  };

  // Get delivery status color and text
  const getDeliveryStatusInfo = (status) => {
    switch(status?.toUpperCase()) {
      case 'DELIVERED':
        return { color: '#155724', bg: '#d4edda', text: 'DELIVERED' };
      case 'PENDING':
        return { color: '#856404', bg: '#fff3cd', text: 'PENDING DELIVERY' };
      case 'CANCELLED':
        return { color: '#721c24', bg: '#f8d7da', text: 'CANCELLED' };
      default:
        return { color: '#856404', bg: '#fff3cd', text: 'PENDING DELIVERY' };
    }
  };

  // Generate QR code data from document number or log_id
  const generateQRCodeData = (docNo, logId) => {
    if (docNo) return docNo;
    return `DO-${logId}`;
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  if (!show || !deliveryData) {
    return null;
  }

  // Generate delivery order number
const deliveryOrderNo = `DO-${deliveryData.log_id}-${moment().format('YYYYMMDD')}`;

// Use document_no as reference if it exists
const referenceNo = deliveryData.document_no || deliveryData.invoiceno;
  
  // Generate QR code data
  const qrCodeData = generateQRCodeData(deliveryData.document_no, deliveryData.log_id);

  // Get delivery status info
  const statusInfo = getDeliveryStatusInfo(deliveryData.delivery_status);

  // Calculate total value
  const totalValue = Math.abs(deliveryData.quantity_change) * deliveryData.price_per_unit;

  return (
    <div className="invoice-modal-overlay" style={{ 
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <div className="invoice-modal" ref={componentRef} style={{ 
        backgroundColor: 'white',
        padding: '16px',
        width: '210mm',
        maxHeight: '90vh',
        overflowY: 'auto',
        position: 'relative',
      }}>
        <span className="modal-close-button" onClick={onClose} style={{
          position: 'absolute',
          top: '8px',
          right: '12px',
          fontSize: '20px',
          cursor: 'pointer',
          zIndex: 1,
          color: '#333',
          fontWeight: 'bold'
        }}>&times;</span>
        
        {/* Header section with logo and company info */}
        <div className="modal-header" style={{ 
          display: 'flex', 
          marginBottom: '12px',
          alignItems: 'flex-start'
        }}>
          {/* Left side - Logo */}
          <div className="company-logo" style={{ 
            width: '70px', 
            height: '70px',
            marginRight: '16px'
          }}>
            <img src="/images/keaes150.png" alt="KEAES" style={{ 
              width: '120%',
              height: 'auto'
            }} />
          </div>
          
          {/* Middle - Company info */}
          <div style={{ flex: 1, paddingTop: '2px' }}>
            <h3 style={{ 
              fontSize: '14px', 
              fontWeight: 'bold', 
              marginBottom: '4px',
              marginTop: 0,
              color: '#333',
              textAlign: 'left',
              marginLeft: '24px'
            }}>Keaes Academics (Ramkhamhaeng)</h3>
            <p style={{ 
              fontSize: '10px', 
              margin: '1px 0',
              lineHeight: '1.2',
              color: '#4a4a4a',
              textAlign: 'left',
              marginLeft: '24px'
            }}>61 Marketplace, 3rd Fl., Ramkhamhaeng Rd,</p>
            <p style={{ 
              fontSize: '10px', 
              margin: '1px 0',
              lineHeight: '1.2',
              color: '#4a4a4a',
              textAlign: 'left',
              marginLeft: '24px'
            }}>Saphan Sung, Bangkok 10240</p>
            <p style={{ 
              fontSize: '10px', 
              margin: '1px 0',
              lineHeight: '1.2',
              color: '#4a4a4a',
              textAlign: 'left',
              marginLeft: '24px'
            }}>02-729-5826</p>
            <p style={{ 
              fontSize: '10px', 
              margin: '1px 0',
              lineHeight: '1.2',
              color: '#4a4a4a',
              textAlign: 'left',
              marginLeft: '24px'
            }}>Email: contact@keaes.com</p>
          </div>
          
          {/* Right side - Delivery Order box */}
          <div style={{ 
            background: 'rgba(200, 200, 200, 0.3)', 
            padding: '12px', 
            color: '#333',
            borderRadius: '6px',
            width: '180px',
            textAlign: 'center',
            marginLeft: 'auto',
            maxWidth: 180
          }}>
            <h2 style={{ 
              color: '#333', 
              fontSize: '16px', 
              margin: '0 0 4px 0',
              fontWeight: 'bold',
              textAlign: 'center'
            }}>
              DELIVERY ORDER
            </h2>
            <div className="delivery-details" style={{ marginBottom: 4 }}>
                <div className="detail-row" style={{ marginBottom: 2 }}>
                    <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    fontSize: '10px', 
                    margin: '2px 0' 
                    }}>
                    <span style={{ fontWeight: 'bold', color: '#333' }}>DO No.:</span>
                    <span style={{ color: '#333', marginLeft: 6 }}>{deliveryOrderNo}</span>
                    </div>
                </div>
                <div className="detail-row" style={{ marginBottom: 2 }}>
                    <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    fontSize: '10px', 
                    margin: '2px 0' 
                    }}>
                    <span style={{ fontWeight: 'bold', color: '#333' }}>Date:</span>
                    <span style={{ color: '#333', marginLeft: 6 }}>{formatDate(deliveryData.timestamp, i18n.language)}</span>
                    </div>
                </div>
                <div className="detail-row" style={{ marginBottom: 2 }}>
                    <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    fontSize: '10px', 
                    margin: '2px 0' 
                    }}>
                    <span style={{ fontWeight: 'bold', color: '#333' }}>Log ID:</span>
                    <span style={{ color: '#333', marginLeft: 6 }}>{deliveryData.log_id}</span>
                    </div>
                </div>
                {/* Add reference number if document_no exists */}
                {referenceNo && (
                    <div className="detail-row">
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        fontSize: '10px', 
                        margin: '2px 0' 
                    }}>
                        <span style={{ fontWeight: 'bold', color: '#333' }}>Reference:</span>
                        <span style={{ color: '#333', marginLeft: 6 }}>{referenceNo}</span>
                    </div>
                    </div>
                )}
                </div>
          </div>
        </div>
        
        {/* Delivery Status Banner */}
        <div style={{
          backgroundColor: statusInfo.bg,
          border: `2px solid ${statusInfo.color}`,
          borderRadius: '6px',
          padding: '8px 16px',
          marginBottom: '12px',
          textAlign: 'center'
        }}>
          <h3 style={{
            color: statusInfo.color,
            fontSize: '14px',
            fontWeight: 'bold',
            margin: 0
          }}>
            STATUS: {statusInfo.text}
          </h3>
          {deliveryData.deliver_date && (
            <p style={{
              color: statusInfo.color,
              fontSize: '11px',
              margin: '2px 0 0 0'
            }}>
              Delivered on: {formatDateTime(deliveryData.deliver_date)}
            </p>
          )}
        </div>
        
        {/* Customer Information */}
        <div className="customer-info" style={{ marginBottom: '12px' }}>
          <h3 style={{ 
            fontSize: '13px', 
            fontWeight: 'bold', 
            marginBottom: '8px',
            color: '#333',
          }}>Customer Information</h3>
          <div style={{
            backgroundColor: '#f9f9f9',
            border: '1px solid #ccc',
            borderRadius: '6px',
            padding: '8px 12px'
          }}>
            <p style={{ fontSize: '11px', margin: '3px 0', color: '#333' }}>
              <strong>Name:</strong> {deliveryData.firstname} {deliveryData.lastname}
              {deliveryData.nickname && <span> ({deliveryData.nickname})</span>}
            </p>
            <p style={{ fontSize: '11px', margin: '3px 0', color: '#333' }}>
              <strong>Student ID:</strong> {deliveryData.student_id || 'N/A'}
            </p>
            <p style={{ fontSize: '11px', margin: '3px 0', color: '#333' }}>
              <strong>Purchase Origin:</strong> {deliveryData.change_reason || 'Standard Delivery'}
            </p>
          </div>
        </div>
        
        <hr style={{ 
          border: 'none', 
          height: '1px', 
          backgroundColor: '#ccc', 
          margin: '12px 0'
        }} />
        
        {/* Delivery Items Table */}
        <div className="delivery-table" style={{ marginTop: '12px' }}>
          <div style={{ 
            width: '100%', 
            fontSize: '11px',
            border: '1px solid #ccc',
            borderRadius: '6px',
            overflow: 'hidden'
          }}>
            {/* Header Row */}
            <div style={{
              background: 'rgba(200, 200, 200, 0.3)', 
              padding: '4px 8px',
              borderBottom: '1px solid #495057',
              fontSize: 11,
              fontWeight: 'bold',
              color: '#333',
              borderRadius: '4px 4px 0 0',
            }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ width: '10%', textAlign: 'center' }}>Product ID</div>
                <div style={{ width: '35%', paddingLeft: '4px' }}>Item Description</div>
                <div style={{ width: '15%', textAlign: 'center' }}>Category</div>
                <div style={{ width: '10%', textAlign: 'center' }}>Quantity</div>
                <div style={{ width: '15%', textAlign: 'right' }}>Unit Price</div>
                <div style={{ width: '15%', textAlign: 'right' }}>Total Value</div>
              </div>
            </div>

            {/* Table Body */}
            <div style={{ 
              backgroundColor: '#ffffff',
              padding: '8px',
              display: 'flex',
              alignItems: 'center',
              minHeight: '32px'
            }}>
              <div style={{ width: '10%', textAlign: 'center', color: '#333', fontWeight: 'bold', fontSize: '11px' }}>
                {deliveryData.product_id}
              </div>
              <div style={{ width: '35%', paddingLeft: '4px', color: '#333', fontWeight: '500', fontSize: '11px' }}>
                {deliveryData.item_name}
              </div>
              <div style={{ width: '15%', textAlign: 'center', color: '#333', fontSize: '11px' }}>
                {deliveryData.category || 'N/A'}
              </div>
              <div style={{ width: '10%', textAlign: 'center', color: '#333', fontSize: '11px', fontWeight: 'bold' }}>
                {Math.abs(deliveryData.quantity_change)}
              </div>
              <div style={{ width: '15%', textAlign: 'right', color: '#333', fontSize: '11px' }}>
                ฿{formatNumber(deliveryData.price_per_unit, i18n.language)}
              </div>
              <div style={{ width: '15%', textAlign: 'right', color: '#333', fontWeight: 'bold', fontSize: '11px' }}>
                ฿{formatNumber(totalValue, i18n.language)}
              </div>
            </div>
          </div>
        </div>
        
        {/* Summary Information */}
        <div className="delivery-summary" style={{ 
          fontSize: 11,
          border: '1px solid #6c757d',
          padding: 8,
          background: 'linear-gradient(135deg, #f9f9f9 0%, #f0f0f0 100%)',
          borderRadius: 6,
          width: 280,
          marginLeft: 'auto',
          marginTop: '12px',
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', margin: '3px 0', color: '#333' }}>
            <span>Total Quantity:</span>
            <span style={{ fontWeight: 'bold' }}>{Math.abs(deliveryData.quantity_change)} Items</span>
          </div>
          
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            margin: '6px 0 4px 0',
            fontWeight: 'bold',
            fontSize: '12px',
            borderTop: '1px solid #6c757d',
            paddingTop: '4px',
            color: '#333'
          }}>
            <span>Total Value:</span>
            <span>฿{formatNumber(totalValue, i18n.language)}</span>
          </div>
        </div>
        
        {/* Delivery Information */}
        <div className="delivery-info" style={{ 
          marginTop: '12px',
          display: 'flex',
          justifyContent: 'center'
        }}>
          <div style={{ 
            fontSize: '10px',
            textAlign: 'center',
            maxWidth: '400px',
            backgroundColor: '#f9f9f9',
            border: '1px solid #ccc',
            borderRadius: '6px',
            padding: '8px 12px'
          }}>
            <div style={{ 
              fontWeight: 'bold', 
              marginBottom: '6px', 
              color: '#333', 
              fontSize: '11px',
              borderBottom: '1px solid #ccc',
              paddingBottom: '3px'
            }}>
              Delivery Information
            </div>
            
            <div style={{ lineHeight: '1.4', color: '#333' }}>
              <div><strong>Transaction Type:</strong> {deliveryData.transaction_type}</div>
              <div><strong>Order Date:</strong> {formatDateTime(deliveryData.timestamp)}</div>
              <div><strong>Delivery Status:</strong> 
                <span style={{ 
                  color: statusInfo.color, 
                  fontWeight: 'bold',
                  marginLeft: '4px'
                }}>
                  {statusInfo.text}
                </span>
              </div>
              {deliveryData.deliver_date && (
                <div><strong>Delivery Date:</strong> {formatDateTime(deliveryData.deliver_date)}</div>
              )}
              {referenceNo && (
                    <div><strong>Reference No:</strong> {referenceNo}</div>
                )}
            </div>
          </div>
        </div>

        {/* Signature Section for Delivery */}
        <div style={{ 
          marginTop: '24px',
          display: 'flex',
          justifyContent: 'space-between',
          padding: '16px 0'
        }}>
          {/* Prepared By */}
          <div style={{ width: '30%', textAlign: 'center' }}>
            <div style={{ 
              fontSize: '11px', 
              fontWeight: 'bold', 
              marginBottom: '60px',
              color: '#333'
            }}>
              Prepared By
            </div>
            <div style={{ 
              borderTop: '1px solid #6c757d', 
              width: '180px', 
              margin: '0 auto',
              paddingTop: '6px',
              fontSize: '10px',
              color: '#333'
            }}>
              KEAES Staff
            </div>
          </div>

          {/* Delivered By */}
          <div style={{ width: '30%', textAlign: 'center' }}>
            <div style={{ 
              fontSize: '11px', 
              fontWeight: 'bold', 
              marginBottom: '60px',
              color: '#333'
            }}>
              Delivered By
            </div>
            <div style={{ 
              borderTop: '1px solid #6c757d', 
              width: '180px', 
              margin: '0 auto',
              paddingTop: '6px',
              fontSize: '10px',
              color: '#333'
            }}>
              {deliveryData?.admin_nickname || '-'}
            </div>
          </div>

          {/* Received By */}
          <div style={{ width: '30%', textAlign: 'center' }}>
            <div style={{ 
              fontSize: '11px', 
              fontWeight: 'bold', 
              marginBottom: '60px',
              color: '#333'
            }}>
              Received By
            </div>
            <div style={{ 
              borderTop: '1px solid #6c757d', 
              width: '180px', 
              margin: '0 auto',
              paddingTop: '6px',
              fontSize: '10px',
              color: '#333'
            }}>
              {deliveryData.firstname} {deliveryData.lastname}
            </div>
          </div>
        </div>

        {/* QR Code and Print Info Footer */}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'flex-end',
          marginTop: '16px',
          marginBottom: '12px',
          padding: '12px 0',
          borderTop: '1px solid #ccc'
        }}>
          {/* QR Code Section */}
          <div style={{ 
            width: '25%', 
            textAlign: 'center'
          }}>
            <QRCodeCanvas
              value={qrCodeData}
              size={50}
              level="M"
            />
            <div style={{ 
              fontSize: '9px', 
              marginTop: '4px', 
              color: '#495057',
              fontFamily: 'monospace',
              wordBreak: 'break-all',
              fontWeight: 'bold'
            }}>
              DELIVERY ORDER
            </div>
          </div>
          
          {/* Note Section */}
          <div style={{ 
            width: '50%', 
            textAlign: 'center',
            padding: '0 16px'
          }}>
            <div style={{ 
              fontSize: '10px', 
              color: '#495057',
              fontStyle: 'italic'
            }}>
              Please check items upon delivery and report any discrepancies immediately.
            </div>
          </div>
          
          {/* Print Info Section */}
          <div style={{ 
            width: '25%', 
            textAlign: 'right', 
            fontSize: '10px', 
            color: '#495057'
          }}>
            <div style={{ fontWeight: 'bold', marginBottom: '3px' }}>
              Generated On:
            </div>
            <div style={{ marginBottom: '1px' }}>
              {moment().format('DD MMM YYYY')}
            </div>
            <div>
              {moment().format('HH:mm:ss')}
            </div>
          </div>
        </div>
        
        {/* Print Button */}
        <div className="delivery-actions" 
            style={{ 
              display: 'flex', 
              justifyContent: 'center',
              marginTop: '12px',
              '@media print': {
                display: 'none'
              }
            }}>
          <button 
            onClick={handlePrint}
            style={{
              padding: '8px 20px',
              backgroundColor: '#6c757d',
              color: 'white',
              border: '1px solid #495057',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '12px',
              fontWeight: 'bold',
              transition: 'all 0.3s ease',
              textShadow: '1px 1px 2px rgba(0,0,0,0.2)'
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#495057';
              e.target.style.transform = 'translateY(-1px)';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = '#6c757d';
              e.target.style.transform = 'translateY(0)';
            }}
          >
            Print Delivery Order
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeliveryOrderModal;